import { css } from '@emotion/core';
import { globalTokens, tokens } from '@domain-group/fe-brary';
export var secondaryColourPath = /*#__PURE__*/css("color:", globalTokens.colors.legacyNavy800, ";");
export var primaryColourPath = /*#__PURE__*/css("color:", globalTokens.colors.legacyPomegranate500, ";");
export var whiteColourPath = /*#__PURE__*/css("color:", tokens.colors.neutral.surface.default, ";");
export var prideColourPaths = [{
  name: "inui0p",
  styles: "fill:#ffda00;"
}, {
  name: "aobebi",
  styles: "fill:#b5d000;"
}, {
  name: "1keorjz",
  styles: "fill:#1356ef;"
}, {
  name: "fy5gv5",
  styles: "fill:#6e2480;"
}, {
  name: "1v5n7nm",
  styles: "fill:#0ea800;"
}, {
  name: "1ve5lhy",
  styles: "fill:#d00e3c;"
}, {
  name: "18n18pk",
  styles: "fill:#feb728;"
}, {
  name: "sxw86z",
  styles: "fill:#fd7a22;"
}];